<template>
  <!-- Desktop -->
  <div v-if="!mobile" class="space-y-5">
    <BookingStatCards :duration="duration" />

    <BookingsOverTime :duration="duration" />

    <div class="grid grid-cols-3 gap-4">
      <div class="col-span-2">
        <BookingActivity :duration="duration" />
      </div>
      <DayBreakdownTable :duration="duration" />
    </div>

    <div class="grid grid-cols-2 gap-4">
      <PopularEvents :duration="duration" />
      <TopAttendees  :duration="duration" />
    </div>
  </div>

  <!-- Mobile -->
  <div v-else class="space-y-4">
    <BookingStatCards  :duration="duration" />
    <BookingsOverTime  :duration="duration" />
    <BookingActivity   :duration="duration" />
    <DayBreakdownTable :duration="duration" />
    <PopularEvents     :duration="duration" />
    <TopAttendees      :duration="duration" />
  </div>
</template>

<script setup>
import { onMounted, watch } from 'vue'
import { useAnalyticsBookingsStore } from 'stores/analyticsBookings.js'
import BookingStatCards  from './BookingStatCards.vue'
import BookingsOverTime  from './BookingsOverTime.vue'
import BookingActivity   from './BookingActivity.vue'
import DayBreakdownTable from './DayBreakdownTable.vue'
import PopularEvents     from './PopularEvents.vue'
import TopAttendees      from './TopAttendees.vue'

const props = defineProps({
  duration: { type: String, required: true },
  mobile:   { type: Boolean, default: false },
})

const store = useAnalyticsBookingsStore()

async function load() {
  await store.fetchAll(props.duration)
}

onMounted(load)
watch(() => props.duration, load)
</script>
